import { ChangeEvent, FC } from 'react'
import { useRootStore } from 'service/useRootStore'
import { useI18n } from 'utils/localisation'

import { upload } from './upload'

interface Props {
  uploadFile: (file: File) => void
  name: string
  allowedFormats?: string[]
}
export const UploadInput: FC<Props> = ({ allowedFormats, name, uploadFile }) => {
  const { uiStore } = useRootStore()
  const { translate } = useI18n()

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (allowedFormats) {
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      const file: File = event.currentTarget.files[0]
      const isFileSupported: boolean = allowedFormats.some((format) => file.name.toLowerCase().endsWith(format))
      if (!isFileSupported) {
        const fileName = file.name
        const fileTypes = allowedFormats.join(', ')
        uiStore.snack.addSnack({
          type: 'error',
          message: translate('documents-upload-error_message', { fileName, fileTypes }),
        })
        return
      }
    }
    upload(event, uploadFile)
    event.target.value = null
  }

  return (
    <input
      style={{
        position: 'absolute',
        width: 0,
        height: 0,
        opacity: 0,
        visibility: 'hidden',
        right: '10000px',
      }}
      onChange={handleOnChange}
      type="file"
      aria-label="File Upload"
      name={name}
      accept={allowedFormats?.join(',')}
    />
  )
}
